import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=cd22550e&scoped=true"
import script from "./editDialog.vue?vue&type=script&lang=ts"
export * from "./editDialog.vue?vue&type=script&lang=ts"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=cd22550e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd22550e",
  null
  
)

export default component.exports